/**
 * simple JWT parser
 * @param token
 * @returns
 */
export const parseJWT = <T extends { iat: number; exp: number; sub: string }>(
  token: string,
): T | null => {
  const [, body = ""] = token.split(".");
  return body ? (JSON.parse(atob(body)) as T) : null;
};
